/* eslint-disable */
/* tslint:disable */

/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
import {NjmmisCheckResult} from './globalTypes' // ====================================================
// GraphQL query operation: Triages
// ====================================================

import {TriagesVariables as TriagesVariablesOrig} from '../types/Triages'
import {Triages as TriagesOrig} from '../types/Triages'
import {Triages_triages as Triages_triagesOrig} from '../types/Triages'
import {Triages_triages_assignedTo as Triages_triages_assignedToOrig} from '../types/Triages'
import {Triages_triages_eligibilityDeterminations as Triages_triages_eligibilityDeterminationsOrig} from '../types/Triages'
import {deserializeNjmmisCheckResult} from 'graphql/converters'
import {serializeNjmmisCheckResult} from 'graphql/converters'
import {Triages_triages_account as Triages_triages_accountOrig} from '../types/Triages'
import {formatISODate} from 'utils/date'
import {parseDate} from 'utils/form/fieldTypes'
import formatISO from 'date-fns/formatISO'
import {Triages_triages_account_person as Triages_triages_account_personOrig} from '../types/Triages'
import {Triages_triages_account_person_assets as Triages_triages_account_person_assetsOrig} from '../types/Triages'
import {Triages_triages_account_person_deductions as Triages_triages_account_person_deductionsOrig} from '../types/Triages'
import {Triages_triages_account_person_incomeSources as Triages_triages_account_person_incomeSourcesOrig} from '../types/Triages'
import {Triages_triages_account_person_phoneNumbers as Triages_triages_account_person_phoneNumbersOrig} from '../types/Triages'
export interface Triages_triages_account_person_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
}
export const deserializeTriages_triages_account_person_phoneNumbers = (
  serialized: Triages_triages_account_person_phoneNumbersOrig
): Triages_triages_account_person_phoneNumbers => ({...serialized})
export const serializeTriages_triages_account_person_phoneNumbers = (
  deserialized: Triages_triages_account_person_phoneNumbers
): Triages_triages_account_person_phoneNumbersOrig => ({...deserialized})
export interface Triages_triages_account_person_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
}
export const deserializeTriages_triages_account_person_incomeSources = (
  serialized: Triages_triages_account_person_incomeSourcesOrig
): Triages_triages_account_person_incomeSources => ({...serialized})
export const serializeTriages_triages_account_person_incomeSources = (
  deserialized: Triages_triages_account_person_incomeSources
): Triages_triages_account_person_incomeSourcesOrig => ({...deserialized})
export interface Triages_triages_account_person_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeTriages_triages_account_person_deductions = (
  serialized: Triages_triages_account_person_deductionsOrig
): Triages_triages_account_person_deductions => ({...serialized})
export const serializeTriages_triages_account_person_deductions = (
  deserialized: Triages_triages_account_person_deductions
): Triages_triages_account_person_deductionsOrig => ({...deserialized})
export interface Triages_triages_account_person_assets {
  __typename: 'Asset'
  id: string
  assetType: string | null
  amount: number | null
}
export const deserializeTriages_triages_account_person_assets = (
  serialized: Triages_triages_account_person_assetsOrig
): Triages_triages_account_person_assets => ({...serialized})
export const serializeTriages_triages_account_person_assets = (
  deserialized: Triages_triages_account_person_assets
): Triages_triages_account_person_assetsOrig => ({...deserialized})
export interface Triages_triages_account_person {
  __typename: 'Person'
  id: string
  updatedAt: Date
  firstName: string | null
  middleName: string | null
  lastName: string | null
  suffix: string | null
  preferredName: string | null
  dob: Date | null
  gender: string | null
  ssn: string | null
  phoneNumbers: Triages_triages_account_person_phoneNumbers[]
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  email: string | null
  emailComment: string | null
  preferredLanguage: string | null
  hospitalPatientId: string | null
  livesInNj: boolean | null
  hasInsurance: boolean | null
  ciStatus: string | null
  fiveYearsInUs: boolean | null
  specialCategory: boolean | null
  ciDocumentType: string | null
  pregnant: boolean | null
  maritalStatus: string | null
  spouseLiveWithMe: boolean | null
  expectedChild: number | null
  taxFilingStatus: string | null
  claimedBySomeoneOtherThanParents: boolean | null
  livingWithParentsWhoDoNotFileJointly: boolean | null
  estTaxDependentCount: number | null
  taxDependentInclSpouseLiveWithClient: boolean | null
  estParentLiveWithClient: number | null
  estChildren19LiveWithClient: number | null
  estMinor19SiblingLiveWithClient: number | null
  estHouseholdIncome: number | null
  incomeSources: Triages_triages_account_person_incomeSources[]
  deductions: Triages_triages_account_person_deductions[]
  assets: Triages_triages_account_person_assets[]
  currentInsuranceName: string | null
  currentInsurancePolicyNo: string | null
  insuranceStartdate: Date | null
  njResidencyDoc: string | null
  ciDocumentName: string | null
  dateOfEntry: Date | null
  uscisNo: string | null
  prCardNo: string | null
  dueDate: Date | null
  spousePregnant: boolean | null
  isStudent: boolean | null
  dependentOfTaxFilerId: string | null
  changeJobInLast6Mon: string | null
  income: boolean | null
  whoSupportWithoutIncome: string | null
  othersSupportWithoutIncome: string | null
  selfSupportWithoutIncome: string | null
  insuranceLast3Months: boolean | null
  wantsCoverage: boolean | null
  alaskanNativeamerican: boolean | null
  fosterCareAfter18: boolean | null
  identityDocument: string | null
  desiredMco: string | null
  pcp: string | null
  childrenPcp: string | null
  note: string | null
  children18LiveWithClient: number | null
  minor18SiblingLiveWithClient: number | null
  pendingUsCitizenship: boolean | null
  livedInNjSinceMonth: string | null
  livedInNjSinceYear: string | null
  hasDeduction: boolean | null
  hasAsset: boolean | null
  noIncomeSinceMonth: string | null
  noIncomeSinceYear: string | null
  noAssetSinceMonth: string | null
  noAssetSinceYear: string | null
  homelessSinceMonth: string | null
  homelessSinceYear: string | null
  supporterRelationship: string | null
  supportSinceMonth: string | null
  supportSinceYear: string | null
  supportType: string[] | null
  supporterAddressStreet: string | null
  supporterAddressCity: string | null
  supporterAddressState: string | null
  supporterAddressZip: string | null
  supporterPhone: string | null
  othersAttestationWho: string | null
  othersAttestationRelationship: string | null
  othersAttestationPhone: string | null
  addressSinceMonth: string | null
  addressSinceYear: string | null
  race: string | null
  currentInsuranceType: string | null
  currentInsuranceIncludesDental: boolean | null
  noIdentityDocReason: string | null
  ownNonresidentProperty: boolean | null
  nonresidentPropertyMailingAddressStreet: string | null
  nonresidentPropertyMailingAddressCity: string | null
  nonresidentPropertyMailingAddressState: string | null
  nonresidentPropertyMailingAddressZip: string | null
  separatedSinceMonth: string | null
  separatedSinceYear: string | null
  dontLiveWithSpouse: boolean | null
  noJointAssetsWithSpouse: boolean | null
  noFinancialSupportFromSpouse: boolean | null
  notFiledJointlySince: string | null
  reasonNotFiling: string | null
  lastKnownAddressStreet: string | null
  lastKnownAddressCity: string | null
  lastKnownAddressState: string | null
  lastKnownAddressZip: string | null
  unreadMessageStatus: boolean | null
}
export const deserializeTriages_triages_account_person = (
  serialized: Triages_triages_account_personOrig
): Triages_triages_account_person => ({
  ...serialized,
  updatedAt: parseDate(serialized.updatedAt),
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeTriages_triages_account_person_phoneNumbers
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeTriages_triages_account_person_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeTriages_triages_account_person_deductions
  ),
  assets: serialized.assets.map(
    deserializeTriages_triages_account_person_assets
  ),
  insuranceStartdate:
    serialized.insuranceStartdate != null
      ? parseDate(serialized.insuranceStartdate)
      : serialized.insuranceStartdate,
  dateOfEntry:
    serialized.dateOfEntry != null
      ? parseDate(serialized.dateOfEntry)
      : serialized.dateOfEntry,
  dueDate:
    serialized.dueDate != null
      ? parseDate(serialized.dueDate)
      : serialized.dueDate,
})
export const serializeTriages_triages_account_person = (
  deserialized: Triages_triages_account_person
): Triages_triages_account_personOrig => ({
  ...deserialized,
  updatedAt: formatISO(deserialized.updatedAt),
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeTriages_triages_account_person_phoneNumbers
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeTriages_triages_account_person_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeTriages_triages_account_person_deductions
  ),
  assets: deserialized.assets.map(
    serializeTriages_triages_account_person_assets
  ),
  insuranceStartdate:
    deserialized.insuranceStartdate != null
      ? formatISODate(deserialized.insuranceStartdate)
      : deserialized.insuranceStartdate,
  dateOfEntry:
    deserialized.dateOfEntry != null
      ? formatISODate(deserialized.dateOfEntry)
      : deserialized.dateOfEntry,
  dueDate:
    deserialized.dueDate != null
      ? formatISODate(deserialized.dueDate)
      : deserialized.dueDate,
})
export interface Triages_triages_account {
  __typename: 'Account'
  id: string
  hospitalAccountId: string | null
  dateOfService: Date
  timeOfService: string | null
  serviceTimeZone: string
  facility: string
  department: string
  location: string | null
  insuranceType: string
  status: string
  createdAt: Date
  updatedAt: Date
  notes: string | null
  accountAmount: number | null
  njmmisCheck: string | null
  previousInsurance: string | null
  invoiceMonth: string | null
  invoiceYear: string | null
  dischargeDate: Date | null
  isScheduled: boolean
  person: Triages_triages_account_person
}
export const deserializeTriages_triages_account = (
  serialized: Triages_triages_accountOrig
): Triages_triages_account => ({
  ...serialized,
  dateOfService: parseDate(serialized.dateOfService),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  njmmisCheck:
    serialized.njmmisCheck != null
      ? deserializeNjmmisCheckResult(serialized.njmmisCheck)
      : serialized.njmmisCheck,
  dischargeDate:
    serialized.dischargeDate != null
      ? parseDate(serialized.dischargeDate)
      : serialized.dischargeDate,
  person: deserializeTriages_triages_account_person(serialized.person),
})
export const serializeTriages_triages_account = (
  deserialized: Triages_triages_account
): Triages_triages_accountOrig => ({
  ...deserialized,
  dateOfService: formatISODate(deserialized.dateOfService),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  njmmisCheck:
    deserialized.njmmisCheck != null
      ? serializeNjmmisCheckResult(deserialized.njmmisCheck)
      : deserialized.njmmisCheck,
  dischargeDate:
    deserialized.dischargeDate != null
      ? formatISODate(deserialized.dischargeDate)
      : deserialized.dischargeDate,
  person: serializeTriages_triages_account_person(deserialized.person),
})
export interface Triages_triages_eligibilityDeterminations {
  __typename: 'EligibilityDetermination'
  id: string
}
export const deserializeTriages_triages_eligibilityDeterminations = (
  serialized: Triages_triages_eligibilityDeterminationsOrig
): Triages_triages_eligibilityDeterminations => ({...serialized})
export const serializeTriages_triages_eligibilityDeterminations = (
  deserialized: Triages_triages_eligibilityDeterminations
): Triages_triages_eligibilityDeterminationsOrig => ({...deserialized})
export interface Triages_triages_assignedTo {
  __typename: 'User'
  id: string
  email: string
  name: string | null
  isCurrentUser: boolean
}
export const deserializeTriages_triages_assignedTo = (
  serialized: Triages_triages_assignedToOrig
): Triages_triages_assignedTo => ({...serialized})
export const serializeTriages_triages_assignedTo = (
  deserialized: Triages_triages_assignedTo
): Triages_triages_assignedToOrig => ({...deserialized})
export interface Triages_triages {
  __typename: 'Triage'
  id: string
  account: Triages_triages_account
  createdAt: Date
  updatedAt: Date
  status: string
  closeReason: string | null
  closeComment: string | null
  eligibilityDeterminations: Triages_triages_eligibilityDeterminations[]
  assignedTo: Triages_triages_assignedTo | null
}
export const deserializeTriages_triages = (
  serialized: Triages_triagesOrig
): Triages_triages => ({
  ...serialized,
  account: deserializeTriages_triages_account(serialized.account),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  eligibilityDeterminations: serialized.eligibilityDeterminations.map(
    deserializeTriages_triages_eligibilityDeterminations
  ),
  assignedTo:
    serialized.assignedTo != null
      ? deserializeTriages_triages_assignedTo(serialized.assignedTo)
      : serialized.assignedTo,
})
export const serializeTriages_triages = (
  deserialized: Triages_triages
): Triages_triagesOrig => ({
  ...deserialized,
  account: serializeTriages_triages_account(deserialized.account),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  eligibilityDeterminations: deserialized.eligibilityDeterminations.map(
    serializeTriages_triages_eligibilityDeterminations
  ),
  assignedTo:
    deserialized.assignedTo != null
      ? serializeTriages_triages_assignedTo(deserialized.assignedTo)
      : deserialized.assignedTo,
})
export interface Triages {
  /**
   * List of triages
   */
  triages: Triages_triages[]
}
export const deserializeTriages = (serialized: TriagesOrig): Triages => ({
  ...serialized,
  triages: serialized.triages.map(deserializeTriages_triages),
})
export const serializeTriages = (deserialized: Triages): TriagesOrig => ({
  ...deserialized,
  triages: deserialized.triages.map(serializeTriages_triages),
})
export interface TriagesVariables {
  statuses?: string[] | null
  departments?: string[] | null
  facilities?: string[] | null
  insuranceTypes?: string[] | null
  njmmisCheck?: (string | null)[] | null
  dateOfService?: string[] | null
  hasDischargeDate?: string[] | null
  isScheduled?: string[] | null
  hasSsn?: string[] | null
  ciStatus?: string[] | null
  unreviewedWebformIds?: string[] | null
  assignedToIds?: string[] | null
}
export const deserializeTriagesVariables = (
  serialized: TriagesVariablesOrig
): TriagesVariables => ({...serialized})
export const serializeTriagesVariables = (
  deserialized: TriagesVariables
): TriagesVariablesOrig => ({...deserialized})
